export { default } from './SectionTerms';